<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="hero-text" style="margin-bottom: 5rem">
        Send multiple job offers with only one submission
      </h1>
    </div>

    <div class="box-shadow" v-if="products.length === 0">
      🚧 Under construction
    </div>

    <div class="box-shadow" v-if="products.length !== 0">
      <div class="pricing-items-container" style="justify-content: center">
        <PricingItemSinglePay
          v-for="(p, i) in products"
          :key="`products-${i}`"
          :ref="`products-${i}`"
          :description="p.description"
          :most-purchased="p.mostPurchased"
          :most-purchased-text="p.mostPurchasedText"
          :name="p.name"
          :id="+p.id"
          :unit-amount="p.unit_amount"
          :currency="p.currency"
          :post-jobs="p.postJobs"
          :subtitle="p.subtitle"
          :mostPurchasedText="p.mostPurchasedText"
          :store-id="storeId"
        />
      </div>
    </div>

    <div style="height: 6rem"></div>

    <!--
    <div class="box-shadow" v-if="subscriptions.length !== 0">
      <h1 class="title-text" style="text-align: center; margin-bottom: 3.5rem">
        Subscription plans
      </h1>

      <div class="pricing-items-container">
        <PricingItem
          v-for="(p, i) in subscriptions"
          :key="`subscriptions-${i}`"
          :ref="`subscriptions-${i}`"
          :description="p.description"
          :most-purchased="p.mostPurchased"
          most-purchased-text="Most popular"
          :name="p.name"
          :prices="p.prices"
          :post-jobs="p.postJobs"
          :mostPurchasedText="p.mostPurchasedText"
        />
      </div>
    </div>
    -->

    <div class="center-items">
      <p>
        Payment secured by
        <a href="https://paddle.com/" rel="external nofollow noopener" target="_blank">Paddle</a>
      </p>
    </div>

    <div class="page-title-container">
      <h1 class="title-text">
        Enjoy all Job Boardy's features
      </h1>
    </div>

    <div class="features-container">
      <div class="feature">
        <div class="icon-container">
          <i class="fas fa-search icon"></i>
        </div>
        <div>
          <h3>Find specific job boards</h3>
          <p class="secondary-text">
            We have a large selection of popular and niche job boards. You can filter them by categories, places and keywords.
          </p>
        </div>
      </div>
      <div class="feature">
        <div class="icon-container">
          <i class="far fa-file-alt icon"></i>
        </div>
        <div>
          <h3>We give you a curated job form</h3>
          <p class="secondary-text">
            An easy to fill job description template with only a few quick steps. Also we give you the option to personalize your job
            description.
          </p>
        </div>
      </div>
      <div class="feature">
        <div class="icon-container">
          <i class="fas fa-chart-line icon"></i>
        </div>
        <div>
          <h3>Keep tracking the status of your job offers</h3>
          <p class="secondary-text">
            Daily updates of where your job offer has been sent to. This is the best way to keep tracking the performance of your job posts.
          </p>
        </div>
      </div>
      <div class="feature">
        <div class="icon-container">
          <i class="far fa-clock icon"></i>
        </div>
        <div>
          <h3>Save time</h3>
          <p class="secondary-text">
            We know you're busy searching the most valuable talents. That's why JobBoardy will send your job offers for you.
          </p>
        </div>
      </div>
      <div class="feature">
        <div class="icon-container">
          <i class="fas fa-people-arrows icon"></i>
        </div>
        <div>
          <h3>Human support</h3>
          <p class="secondary-text">
            If you have any problem or anything to say, just contact us
            <a @click="$router.push({ path: '/help' })">here</a>. We're humans so we'll help you as soon as we can personally.
          </p>
        </div>
      </div>
    </div>
  </div>

  <NewsletterCTA />

  <CulDeSac />
</template>

<script>
// import PricingItem from "@/components/PricingItem";
import PricingItemSinglePay from "@/components/PricingItemSinglePay";
import CulDeSac from "@/components/CulDeSac";
import NewsletterCTA from "@/components/NewsletterCTA";
import firebase from "@/firebase";

export default {
  components: {
    CulDeSac,
    // PricingItem,
    PricingItemSinglePay,
    NewsletterCTA,
  },

  created() {
    window.scrollTo(0, 0);

    this.initializeStore();
  },

  data() {
    return {
      interval: "month",
      alreadyUsed: false,
      serverError: false,
      showEmailBadFormat: false,
      products: [],
      subscriptions: [],
      storeId: null,
    };
  },

  methods: {
    async initializeStore() {
      await firebase.remoteConfig.fetchAndActivate();

      const storeString = firebase.remoteConfig.getValue("active_store").asString();
      const storeConfig = JSON.parse(storeString);
      this.storeId = storeConfig.id;

      firebase.firestore
        .collection("store")
        .doc(this.storeId)
        .collection("products")
        .where("isActive", "==", true)
        .get()
        .then((s) => {
          this.products = s.docs.map((s) => {
            const data = s.data();
            data.id = s.id;
            return data;
          });
        })
        .catch((error) => {
          console.error("Error getting products: ", error);
        });

      firebase.firestore
        .collection("store")
        .doc(this.storeId)
        .collection("subscriptions")
        .where("isActive", "==", true)
        .get()
        .then((s) => {
          this.subscriptions = s.docs.map((s) => {
            const data = s.data();
            data.id = s.id;
            return data;
          });
        })
        .catch((error) => {
          console.error("Error getting products: ", error);
        });
    },

    select(ref, model) {
      ref.focus();
      ref.setSelectionRange(0, model.length);
    },

    setInterval(interval) {
      this.interval = interval;

      for (const i in this.$refs) {
        if (i.startsWith("item-")) {
          this.$refs[i].interval = interval;
        }
      }
    },
  },
};
</script>

<style></style>
